import React from 'react'
import {Message} from 'semantic-ui-react'
const ErrorMessage = ({errorMessage}) => {
  return <Message error header={errorMessage} />
}

export default ErrorMessage
